import React from 'react';
import Breadcrumb from '../../components/navigation/Breadcrumb';
import { useQuery } from '@apollo/client';
import { GET_PROVIDER_CONTENT } from '../../utils/api/library';
import Table from '../../components/lists/Table/Table';
import { DateCell } from '../../components/lists/Table/shared/DateCell';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';

const pages = [{name: 'Article Templates', href: '/library/article-templates', current: true}]

const columns = [
  {
    dataIndex: 'projectTitle',
    title: 'Project',
    key: 'project',
  },
  {
    dataIndex: 'title',
    title: 'Name',
    key: 'name',
  },
  {
    dataIndex: 'updatedAt',
    title: 'Last updated',
    render: (updatedAt) => <DateCell value={updatedAt} />,
    key: 'updated',
  },
  {
    dataIndex: 'previewUrl',
    title: 'Preview',
    key: 'preview',
    render: (previewUrl) => (
      <a href={previewUrl} target='_blank' rel='noreferrer' className='flex'>
        <ArrowTopRightOnSquareIcon
          className='h-5 w-5 mx-4'
          aria-hidden='true'
        />
      </a>
    ),
  },
]

const ArticleTemplates = () => {

  const {loading, error, data} = useQuery(GET_PROVIDER_CONTENT, {
    // variables,
  })

  const items = data ? data.ProviderContentMany.items : []

  return (
    <>
      <div className='mb-4 flex items-center justify-between'>
        <Breadcrumb pages={pages} />
      </div>

      <Table
        searchable={false}
        columns={columns}
        loading={loading}
        data={items}
        rowKey="_id"
      />

    </>
  );
};

export default ArticleTemplates;

